var _circle, _rect, _rect2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAuthSucc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 100,
    r: 100,
    fill: "#F3F6FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.5,
    y: 60,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#407EDB",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 64,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#2EBE8A",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 99L96.5 113L120 89.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthSucc);
export default __webpack_public_path__ + "static/media/icon_auth_succ.7b23d78206766af5b53004cd34ff8d53.svg";
export { ForwardRef as ReactComponent };